import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import LeadReportLayer from '../components/reports/leadReportLayer'

export const LeadReportPage = () => {
  return (
    <MasterLayout>
        <LeadReportLayer />
    </MasterLayout>
    );
};

export default LeadReportPage;